export const COOKIE_KEYS = {
    AUTO_LOGGED_OUT: 'user-auto-logged-out',
} as const;

export type CookieKeys = (typeof COOKIE_KEYS)[keyof typeof COOKIE_KEYS];
